import champsService from '../services/champsService'

const state = {
  clubCode: null,
  clubRating: null,
  clubRatingCount: null,
  clubRatingSettings: {},
  clubRatingLoading: false
}

const mutations = {
  saveClubRating (state, data) {
    state.clubRating = data.items
    state.clubRatingCount = data.totalCount
  },
  saveClubRatingSettings (state, data) {
    state.clubRatingSettings = data
  }
}

const getters = {}

const actions = {
  getClubRating ({ state, commit }, data) {
    state.clubRatingLoading = true
    return champsService.getClubMembersRating(data)
      .then(response => {
        commit('saveClubRating', {
          items: response.data.items,
          totalCount: response.data.totalCount
        })
        state.clubCode = data.clubCode
        state.clubRatingLoading = false
      })
      .catch((error) => {
        if (error.message !== 'canceled') {
          state.clubRatingLoading = false
        }
      })
  }
}

export const clubRating = {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
